
export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const isWebView = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('wv') || // Android webview
         (isIOS() && !window.navigator.standalone && !/safari|chrome|firefox/i.test(userAgent));
};